import { Component, Input } from '@angular/core';

@Component({
  selector: 'status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent {

  @Input() text = 'Status';
  @Input() backgroundColor = '#FA0';
  @Input() textColor = '#000000';
}
